/**
 * Откуда в приложение приходит токен приглашения.
 *
 * Путей три, и каждый нужен:
 *  1. Ссылка `t.me/<бот>?startapp=inv_<токен>` — параметр запуска Telegram.
 *     Работает, только если в BotFather у бота включено главное приложение
 *     (Main Mini App); иначе Telegram открывает чат, и параметр теряется.
 *  2. Кнопка «Принять приглашение» от бота на `/start inv_<токен>` — токен
 *     лежит в адресе: `/invite?token=<токен>` (bot/keyboards.py, deep_link_path).
 *  3. Ссылка, которую няня вставила руками на экране ожидания, — когда первые
 *     два пути не сработали.
 */

import { getStartParam } from '@/shared/telegram'

// secrets.token_urlsafe на сервере: латиница, цифры, «_» и «-».
const TOKEN = '[A-Za-z0-9_-]{10,}'

/** Токен из того, как открыли приложение: параметр запуска или адрес кнопки бота. */
export function inviteTokenFromLaunch(): string | undefined {
  const start = getStartParam()
  if (start?.startsWith('inv_')) return start.slice(4)

  if (window.location.pathname.startsWith('/invite')) {
    const token = new URLSearchParams(window.location.search).get('token')
    if (token && new RegExp(`^${TOKEN}$`).test(token)) return token
  }
  return undefined
}

/**
 * Токен из текста, который человек вставил сам.
 *
 * Принимаем и полную ссылку, и адрес кнопки бота, и голый токен: пересылая
 * ссылку, люди часто копируют её вместе с текстом сообщения вокруг.
 */
export function parseInviteToken(input: string): string | undefined {
  const text = input.trim()
  const fromLink =
    text.match(new RegExp(`inv_(${TOKEN})`)) ?? text.match(new RegExp(`[?&]token=(${TOKEN})`))
  if (fromLink) return fromLink[1]
  if (new RegExp(`^${TOKEN}$`).test(text)) return text
  return undefined
}
